export const resources = [

    {
        type: "website",
        title: "Bring Your Brave Campaign",
        isOver40: false,
        isInsured: true,
        forCase: ["case2"],
        organization: "Center for Disease Control and Prevention",
        url: "https://www.cdc.gov/cancer/breast/young_women/bringyourbrave/index.htm",
        doctorLikes: 3,
        likes: 5,
        tags: ["Campaign"],
        searchTerms:["under40", "breast cancer", "campaign"]
    },
  {
        type: "event",
        title: "Mobile Mammogram Screening in Long Island City",
        isOver40: false,
        isInsured: true,
        forCase: ["case2"],
        organization: "October 12, 10am - 4pm",
        url: "https://www.cancer.org/",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["over40", "breast cancer"],
    },

    {
        type: "website",
        title: "Should women under age 40 get mammograms?",
        isOver40: false,
        isInsured: true,
        forCase: ["case2"],
        organization: "Cleveland Clinic",
        url: "https://my.clevelandclinic.org/health/articles/16805-breast-cancer-in-young-women",
        doctorLikes: 3,
        likes: 5,
        tags: "",
        searchTerms:["under40", "breast cancer"]
    },
  
      {
        type:"website",
        title: "Breast Cancer Early Detection and Diagnosis",
        isOver40: false,
        isInsured: false,
        forCase: ["case2"],
        organization: "American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["over40", "breast cancer"],
    },

    {
        type: "video",
        title: "Breast cancer affects young women too",
        isOver40: false,
        isInsured: true,
        forCase: ["case2", "case3"],
        organization: "abc KSAT 12",
        url: "https://www.youtube.com/watch?v=I9_7zWoy7v4",
        doctorLikes: 3,
        likes: 5,
        tags: "",
        searchTerms:["under40", "breast cancer"]
    },

    {
        type: "website",
        title: "How to do a breast self-exam: The five steps",
        isOver40: false,
        isInsured: true,
        forCase: ["case2", "case1", "case3", "case4"],
        organization: "breastcancer.org",
        url: "https://www.breastcancer.org/symptoms/testing/types/self_exam",
        doctorLikes: 3,
        likes: 5,
        tags: "",
        searchTerms:["under40", "breast cancer", "self-exam,"]
    },


    {
        type: "website",
        title: "Zocdoc: Appointment/ Search doctor App",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "Zocdoc",
        url: "https://www.zocdoc.com/",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["appointment", "zocdoc"],
    },

    {
        type: "website",
        title: "Tips for choosing a new primary care physician",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "BlueCross BlueSheild",
        url:
            "https://www.bcbs.com/five-tips-choosing-new-primary-care-physician",
        doctorLikes: 3,
        likes: 5,
        tags: ["Tips"],
        searchTerms: ["tips", "primary doctor", "primary care physician"],
    },

    {
        type: "website",
        title: "5 tips to prepare for doctor’s visits",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "HealthCare.gov",
        url: "https://www.healthcare.gov/blog/get-ready-doctors-appointment/",
        doctorLikes: 3,
        likes: 5,
        tags: ["Tips"],
        searchTerms: [
            "tips",
            "prepare",
            "doctor visit",
            "primary doctor",
            "primary care physician",
        ],
    },

    {
        type: "website",
        title: "Tips for Getting a Mammogram",
        organization: "The American Cancer Society",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/mammograms/mammograms-what-to-know-before-you-go.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Tips"],
        searchTerms: ["tips", "prepare", "mammogram", "what to expect"],
    },

    {
        type: "website",
        title: "Breast Ultrasound",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/breast-ultrasound.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Test"],
        searchTerms: ["other test", "breast cancer test", "test", "ultrasound"],
    },

    {
        type: "website",
        title: "Breast MRI",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/breast-mri-scans.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Test"],
        searchTerms: ["other test", "breast cancer test", "test", "mri"],
    },

    {
        type: "website",
        title: "Breast Biopsy",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/breast-biopsy.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Test"],
        searchTerms: ["other test", "breast cancer test", "test", "biopsy"],
    },

    {
        type: "website",
        title: "Finding Breast Cancer During Pregnancy",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/finding-breast-cancer-during-pregnancy.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Test", "pregnancy"],
        searchTerms: ["other test", "breast cancer test", "test", "pregnancy"],
    },

    {
        type: "website",
        title: "Getting Called Back After a Mammogram",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/mammograms/getting-called-back-after-a-mammogram.html",
        doctorLikes: 3,
        likes: 5,
        tags: "",
        searchTerms: [
            "other test",
            "breast cancer test",
            "test",
            "called back",
            "second test",
            "Mammogram",
        ],
    },

    {
        type: "website",
        title: "How can I stay calm while waiting?",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/mammograms/getting-called-back-after-a-mammogram.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: [
            "wait for result",
            "breast cancer test",
            "waiting",
            "stay calm",
            "anxiety",
            "worry",
        ],
    },

    {
        type: "website",
        title: "Questions to Ask Your Doctor When You Have Cancer",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/treatment/finding-and-paying-for-treatment/choosing-your-treatment-team/questions-to-ask-your-doctor.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: [
            "prepare",
            "question",
            "ask doctort",
            "have cancer",
            "got cancer",
        ],
    },

    {
        type: "website",
        title: "Understanding Your Mammogram Report",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/mammograms/understanding-your-mammogram-report.html",
        doctorLikes: 3,
        likes: 5,
        tags: "",
        searchTerms: ["read mammogram", "read report", "report", "mammogram"],
    },

    {
        type: "phone",
        title: "The American Cancer Society Support Number",
        isOver40: true,
        isInsured: true,
        forCase: ["case1"],
        organization: "The American Cancer Society",
        phoneNumber: "1-800-227-2345",
        url:
            "https://www.cancer.org/cancer/breast-cancer/screening-tests-and-early-detection/mammograms/getting-called-back-after-a-mammogram.html",
        doctorLikes: 3,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["anxiety", "phone call", "wait for result", "support"],
    },
  
  {
        type: "website",
        title: "Mammogram Procedure",
        isOver40: true,
        isInsured: false,
        forCase: ["case3"],
        organization: "John Hopkins Medicine",
        url: "https://www.hopkinsmedicine.org/health/treatment-tests-and-therapies/mammogram-procedure",
        doctorLikes: 10,
        likes: 8,
        tags: ["mammogram"],
        searchTerms:["over40", "Recommended"]
    },
  
    {
        type: "video",
        title: "What You Should Know Before Your First Mammogram",
        isOver40: true,
        isInsured: false,
        forCase: ["case3"],
        organization: "Center for Diagnostic Imaging",
        url: "https://www.youtube.com/watch?v=MGsWSQGmFnY&t=1s",
        doctorLikes: 7,
        likes: 5,
        tags: ["firstmammogram"],
        searchTerms:["First Mammogram", "Recommended"]
    },
    {
        type: "website",
        title: "What women under 40 should be doing to detect breast cancer",
        isOver40: false,
        isInsured: false,
        forCase: ["case3" , "case2"],
        organization: "Centers for Disease Control and Prevention (CDC)",
        url: "https://www.today.com/health/what-women-under-40-should-be-doing-detect-breast-cancer-t159260",
        doctorLikes: 3,
        likes: 8,
        tags: ["mammogram"],
        searchTerms:["Under40", "Recommended"]
    },
    {
        type: "video",
        title: "How To Catch Breast Cancer Early: Stanford Doctors Explain Mammography Options",
        isOver40: false,
        isInsured: false,
        forCase: ["case3", "case2"],
        organization: "Stanford Health Care",
        url: "https://www.youtube.com/watch?v=ql11xKFMKg4",
        doctorLikes: 10,
        likes: 8,
        tags: ["mammogram"],
        searchTerms:["Under40", "Recommended"]
    },
    {
        type: "website",
        title: "Five Things Women Under 40 Should Know About Breast Cancer",
        isOver40: false,
        isInsured: false,
        forCase: ["case3"],
        organization: "Beth Israel Deaconess Medical Center",
        url:"https://www.bidmc.org/about-bidmc/wellness-insights/breast-health/2019/09/five-things-women-under-40-should-know-about-breast-cancer",
        doctorLikes: 9,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended"],
    },
    {
        type: "video",
        title: "Breast Cancer in Women of Color: 2015 Update",
        isOver40: false,
        isInsured: false,
        forCase: ["case3"],
        organization: "NYU Langone Health",
        url:"https://youtu.be/0pYXmwVeH40",
        doctorLikes: 8,
        likes: 8,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended"],  
    },
    {
        type: "website",
        title: "The Fight Against Breast Cancer Illustrates the Health-Care Challenges of Women in Poverty",
        isOver40: false,
        isInsured: false,
        forCase: ["case3"],
        organization: "The ASCO Post",
        url:"https://ascopost.com/issues/september-25-2019/breast-cancer-and-health-care-challenges-of-women-in-poverty/",
        doctorLikes: 5,
        likes: 3,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended"], 
    },
    {
        type: "event",
        title: "Strength in Stories: Virtual Celebration",
        isOver40: false,
        isInsured: false,
        forCase: ["case3, case2, case1, case4"],
        organization: "Living Beyond Breast Cancer: November 7, 2020 5pm to 6pm",
        url:"https://www.lbbc.org/programs-events/strength-stories-virtual-celebration?gclid=CjwKCAjwq_D7BRADEiwAVMDdHspOnRelffyADvXaHgloZkp9X4BuhInMXExKuF_u64VbrWBJcW_gaxoC48YQAvD_BwE",
        doctorLikes: 8,
        likes: 9,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended, over40"], 
    },
    {
        type: "event",
        title: "The First-Ever Virtual Symposium & Awards Luncheon",
        isOver40: false,
        isInsured: false,
        forCase: ["case3, case2, case1, case4"],
        organization: "Breast Cancer Research Foundation: October 16, 2020 | 10:15 am",
        url:"https://www.bcrf.org/events/first-ever-virtual-symposium-awards-luncheon",
        doctorLikes: 10,
        likes: 5,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended, over40"],
    },
    {
        type: "event",
        title: "Westchester Hot Pink: A Virtual Evening with the Experts",
        isOver40: false,
        isInsured: false,
        forCase: ["case3, case2, case1, case4"],
        organization: " Breast Cancer Research Foundation: October 28, 2020 | 5:30 pm",
        url:"https://www.bcrf.org/events/westchester-hot-pink-virtual-evening-experts",
        doctorLikes: 7,
        likes: 9,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended, over40"],
    },
    {
        type: "event",
        title: "Boston Hot Pink Virtual Luncheon & Symposium",
        isOver40: false,
        isInsured: false,
        forCase: ["case3, case2, case1, case4"],
        organization: "Breast Cancer Research Foundation: October 23, 2020 | 12:00 pm",
        url:"https://www.bcrf.org/events/boston-hot-pink-virtual-luncheon-symposium",
        doctorLikes: 6,
        likes: 8,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended, over40"],
    },
    {
        type: "event",
        title: "Paint For A Cause W/ Johnny Depp Impersonator",
        isOver40: false,
        isInsured: false,
        forCase: ["case3, case2, case1, case4"],
        organization: "El Rene Promotions: Wed, October 7, 2020 | 7:30 PM – 9:30 PM EDT",
        url:"https://www.eventbrite.com/e/paint-for-a-cause-w-johnny-depp-impersonator-tickets-93014084631",
        doctorLikes: 5,
        likes: 10,
        tags: ["Recommended"],
        searchTerms: ["Under40, breast cancer, Recommended, over40"],
    }
];

